var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApzBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EDEFF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55971 22H6.08243L10.3552 10.3636H11.8097L16.0824 22H14.6052L11.1279 12.2045H11.037L7.55971 22ZM8.10516 17.4545H14.0597V18.7045H8.10516V17.4545ZM17.8949 22V10.3636H21.8268C22.7396 10.3636 23.4858 10.5284 24.0654 10.858C24.6487 11.1837 25.0805 11.625 25.3608 12.1818C25.6411 12.7386 25.7813 13.3598 25.7813 14.0455C25.7813 14.7311 25.6411 15.3542 25.3608 15.9148C25.0843 16.4754 24.6563 16.9223 24.0768 17.2557C23.4972 17.5852 22.7548 17.75 21.8495 17.75H19.0313V16.5H21.804C22.429 16.5 22.9309 16.392 23.3097 16.1761C23.6885 15.9602 23.9631 15.6686 24.1336 15.3011C24.3078 14.9299 24.3949 14.5114 24.3949 14.0455C24.3949 13.5795 24.3078 13.1629 24.1336 12.7955C23.9631 12.428 23.6866 12.1402 23.304 11.9318C22.9214 11.7197 22.4139 11.6136 21.7813 11.6136H19.304V22H17.8949Z",
    fill: "#A6AFBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApzBanner);
export default __webpack_public_path__ + "static/media/apz-banner.e6c24cb93993253b634e6f6d121f41d3.svg";
export { ForwardRef as ReactComponent };